import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { faqs } from "../../data/faqs";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-152" data-mp="urkowa5r2j60">
      <div className="mx-auto max-w-3xl" data-id="element-153" data-mp="70f21b1e6qm7">
        <SectionHeading title="Frequently asked questions" data-id="element-154" data-mp="71glo3wh4lfj" />

        <div className="mt-10 divide-y divide-line overflow-hidden rounded-3xl bg-white ring-1 ring-line" data-id="element-155" data-mp="236t8124vyxm">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-156" data-mp="bz9wja8q23m5" data-mpi={i}>
                <h3 data-id="element-157" data-mp="c2nwkbtwy0qf">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 hover:bg-canvas sm:px-7" data-id="element-158" data-mp="1seb1o91wjlj7">
                    <span className="text-base font-bold leading-snug text-navy sm:text-lg" data-id="element-159" data-mp="rrx3epu69qic">{faq.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-160" data-mp="vt8k25v2j1ee" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-161" data-mp="3zydp0tz7slo">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-162" data-mp="82mp9ga2rdmc">
                      <div className="space-y-2 px-5 pb-5 text-base leading-relaxed text-muted sm:px-7" data-id="element-163" data-mp="nnemxl92qu0t">
                        {faq.answer.map(p => <p key={p} data-id="element-164" data-mp="xfbywu7wpq0l">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCta label="Get my Blueprint™ now for $27" data-id="element-165" data-mp="4qn3nbtj8ewr" />
      </div>
    </section>;
}